import styled from "styled-components";

import { theme } from "../../themes/themes";
export const FontsFormContainer = styled.div`
  margin: 10px;
  height: 100%;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;

  #font-picker-1 {
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    border-radius: 3px !important;
    box-shadow: none !important;
  }

  #font-picker-2 {
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    border-radius: 3px !important;
    box-shadow: none !important;
  }

  #font-picker-3 {
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    border-radius: 3px !important;
    box-shadow: none !important;
  }
  #font-picker-4 {
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    border-radius: 3px !important;
    box-shadow: none !important;
  }

  .expanded {
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    border-radius: 3px !important;
    box-shadow: none !important;
  }

  .dropdown-button {
    background: none !important;
    border-radius: 3px !important;
    border: 1px solid ${({ theme }) => theme.text.disabled} !important;
  }

  ul {
    background: white !important;
  }

  .expanded ul {
    max-height: 120px !important;
  }
`;

export const TitleContainer = styled.span`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 25px;
  letter-spacing: 0.01em;
  color: #232323;
  margin-bottom: 25px;
  margin-top: 10px;
  grid-row: 1;
`;

export const EditSection = styled.div`
  margin: 10px;
  align-items: center;
  justify-self: center;
  display: grid;
  grid-template-columns: 2fr;
  font-size: 14px;
  border-radius: 5px;
  word-break: break-word;
  width: 90%;

  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const FontSection = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  align-items: center;
  grid-gap: 1em;

  input {
    justify-self: left;
    height: 2.4em;
    width: 100%;
    border: 1px solid rgba(240, 240, 240, 1);
    background: RGBA(250, 250, 250, 1);
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }
`;

export const FontFieldSection = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 1em;

  input,
  select {
    height: 2rem;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }

  #mText {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const StyledButton = styled.button`
  justify-self: center;
  margin-right: 0.4rem;
  width: 100%;
  height: 2rem;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.text.disabled};
  background: none;
`;
